import { Injectable } from '@angular/core';

import { extract, hasProvider, VideoTypeData, OembedData } from 'oembed-parser';

/**
 * Based on oembed: https://oembed.com
 */
@Injectable({
  providedIn: 'root',
})
export class OembedService {
  /**
   * Returns an HTML string
   */
  getOembedVideo = async (
    url?: string,
    maxWidth?: number,
    maxHeight?: number
  ): Promise<string | null> => {
    if (url) {
      const result: OembedData | null = await this.getOembed(url, {
        maxwidth: maxWidth,
        maxheight: maxHeight,
      });
      if (result && result.type == 'video') {
        return (result as VideoTypeData).html;
      } else {
        return null;
      }
    }
    return null;
  };

  /**
   * Returns one of the following result types:
   *    'rich' | 'video' | 'photo' | 'link'
   */
  private getOembed = async (
    url: string,
    params?: any
  ): Promise<OembedData | null> => {
    try {
      if (hasProvider(url)) {
        return await extract(url, params);
      } else {
        console.error('No provider for URL', url);
        return null;
      }
    } catch (err) {
      console.trace(err);
      return null;
    }
  };

  /**
   * Returns whether the given URL
   *  - has a provider, and
   *  - the provider returns a valid response
   */
  isEmbeddable = async (url: string): Promise<boolean> => {
    try {
      if (hasProvider(url)) {
        return !!(await extract(url));
      } else {
        return false;
      }
    } catch (err) {
      return false;
    }
  };
}
